import React, { useContext } from 'react';

import { isFeatureEnabled, FEATURES } from '../../../helpers/feature_checker.js';
import Context from '../../../utils/context';
import LegacyConversationRoom from './legacy_conversation_room';
import NewConversationRoom from './new_conversation_room';

export default function ConversationRoom(props) {
  const context = useContext(Context);
  const currentAccount = context.auth.currentAccount();
  const isNewUiEnabled = isFeatureEnabled(currentAccount, FEATURES.NEW_UI);

  return isNewUiEnabled ? <NewConversationRoom {...props} /> : <LegacyConversationRoom {...props} />;
}
